import React from "react";
import { Link } from "react-router-dom";

// items: [{ label, to? }] — the last item (no `to`) renders as the current page.
export default function Breadcrumb({ items = [], className = "" }) {
  if (!items.length) return null;
  return (
    <nav data-testid="breadcrumb" className={`flex items-center gap-2 text-xs text-neutral-500 flex-wrap ${className}`}>
      {items.map((it, i) => (
        <React.Fragment key={it.to || `${it.label}-${i}`}>
          {i > 0 && <span className="text-neutral-300">›</span>}
          {it.to ? (
            <Link to={it.to} className="hover:text-black transition-colors" data-testid={`breadcrumb-${i}`}>{it.label}</Link>
          ) : (
            <span className="text-neutral-800 truncate max-w-[260px]" data-testid="breadcrumb-current">{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
